// extracted by mini-css-extract-plugin
export default {"bpk-icon-description":"withDescription_bpk-icon-description__ODNjM"};